import { useMutation, useQueryClient } from 'react-query';
import {
  switchBettieProfilePicture,
  type SwitchBettieProfilePictureBody,
  type SwitchBettieProfilePictureResponse
} from '../../services/bettieProfileService';

export function useSwitchBettieProfilePicture(chatRoomId: string) {
  const queryClient = useQueryClient();
  return useMutation<SwitchBettieProfilePictureResponse, Error, SwitchBettieProfilePictureBody>(
    (body) => switchBettieProfilePicture(chatRoomId, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['bettieChatRoomPictures', chatRoomId]);
      }
    }
  );
}
